import React, { useEffect, useState } from "react";
import MangeDashboard from "./ManageDashboard";
import { useLocation, useNavigate } from "react-router-dom";
import BalanceInfo from "./BalanceInfo";
import Deposit from "./Deposit";
import Bardasht from "./Bardasht";
import AfterLoginNav from "../AfterLoginNav";
import { toPersianNum } from "../../utils/persianNumbers";
import { getBankAccounts, getTransactionsHistory } from "../../services/bank";
let history = [];
export default function Kifpool() {
  const location = useLocation();
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const [active, setActive] = useState("balance");
  const [activeFilters, setActiveFilters] = useState(false);
  const [filterValue, setFilterValue] = useState(1);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  useEffect(() => {
    function fetchData() {
      getBankAccounts()
        .then((res) => {
          if (res.status == 200) {
            let option = res?.data?.results;
            let cardd = option.map((opt) => {
              return { value: opt.card_number, lable: opt.card_number };
            });
            setCards(cardd);
          }
        })
        .catch(() => {});
    }
    fetchData();
  }, []);

  useEffect(() => {
    function fetchData() {
      getTransactionsHistory(page, 5)
        .then((res) => {
          if (res.status == 200) {
            setHasNext(res?.data?.next);
            history = [...filteredHistory, ...res.data.results];
            setFilteredHistory([...filteredHistory, ...res?.data?.results]);
          }
        })
        .catch(() => {});
    }
    fetchData();
  }, [page]);

  useEffect(() => {
    if (filterValue === 2) {
      setFilteredHistory([...history]);
    } else if (filterValue === 1) {
      let his = [...history];
      let filtered = his.filter((item) => item.cash_amount < 0);
      setFilteredHistory([...filtered]);
    } else {
      let his = [...history];
      console.log(his);
      let filtered = his.filter((item) => item.cash_amount >= 0);
      setFilteredHistory([...filtered]);
    }
  }, [filterValue]);
  function toggleFilters() {
    setActiveFilters(!activeFilters);
  }
  return (
    <MangeDashboard>
      <AfterLoginNav
        title={"کیف پول"}
        hasBack={() => {
          const doesAnyHistoryEntryExist = location.key !== "default";
          if (doesAnyHistoryEntryExist) {
            navigate(-1);
          } else {
            navigate("/");
          }
        }}
      />
      <div className="kifpool-container">
        <div className="container pt-kifpool">
          <div className="row justify-content-center h-100 align-items-center">
            <div className="col-12 col-md-8">
              <div className="kifpool-main-wrapper">
                <div className="wallet-tabs-items">
                  <div
                    className={
                      active == "balance"
                        ? "form-input-button-custom"
                        : "form-input-button-custom not-active-login"
                    }
                    onClick={() => setActive("balance")}
                  >
                    موجودی
                  </div>
                  <div
                    className={
                      active == "wed"
                        ? "form-input-button-custom"
                        : "form-input-button-custom not-active-login"
                    }
                    onClick={() => setActive("wed")}
                  >
                    برداشت
                  </div>
                  <div
                    className={
                      active == "dep"
                        ? "form-input-button-custom"
                        : "form-input-button-custom not-active-login"
                    }
                    onClick={() => setActive("dep")}
                  >
                    افزایش موجودی
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="authincation section-padding">
            <div className="container h-100">
              <div className="row justify-content-center h-100 align-items-center">
                <div className="col-12 col-md-8">
                  <div className="auth-form kifpool-content-wrapper custom-shadow">
                    <div>
                      {active == "balance" && (
                        <>
                          <div className="filter-items" onClick={toggleFilters}>
                            <img src={"/images/svg/filters.svg"} alt={""} />
                            فیلترها
                          </div>
                          {activeFilters && (
                            <>
                              <div className="filters-item-row">
                                <input
                                  type="radio"
                                  name="filter"
                                  value={2}
                                  checked={filterValue === 2}
                                  onChange={() => setFilterValue(2)}
                                  id="all-transactions"
                                />
                                <label
                                  htmlFor="all-transactions"
                                  className="filter-transactions-label"
                                >
                                  همه تراکنش ها
                                </label>
                              </div>
                              <div className="filters-item-row">
                                <input
                                  type="radio"
                                  name="filter"
                                  value={0}
                                  checked={filterValue === 0}
                                  onChange={() => setFilterValue(0)}
                                  id="income-transactions"
                                />
                                <label
                                  htmlFor="income-transactions"
                                  className="filter-transactions-label"
                                >
                                  فقط واریزی ها
                                </label>
                              </div>
                              <div className="filters-item-row">
                                <input
                                  type="radio"
                                  name="filter"
                                  value={1}
                                  checked={filterValue === 1}
                                  onChange={() => setFilterValue(1)}
                                  id="outcome-transactions"
                                />
                                <label
                                  htmlFor="outcome-transactions"
                                  className="filter-transactions-label"
                                >
                                  فقط برداشتی ها
                                </label>
                              </div>
                            </>
                          )}
                          <div className="kifpoot-content-info">
                            <BalanceInfo />
                          </div>
                          <div className="history-container-items">
                            {filteredHistory.map((li) => (
                              <div className="history-row-kifpool-item">
                                <div className="history-title-label">
                                  <span className="text-css75-order">
                                    {li["type"] == 0 ? <>واریز</> : <>برداشت</>}
                                  </span>
                                </div>
                                <div className="history-transaction-date">
                                  <span className="text-css75-order">
                                    {toPersianNum(
                                      li["created_at"].split("T")[0]
                                    )}
                                  </span>
                                </div>
                                <div className="history-cash-amount">
                                  <span className="text-css75-order">
                                    {new Intl.NumberFormat("fa", {
                                      maximumFractionDigits: 0,
                                    }).format(Math.abs(li["cash_amount"]))}{" "}
                                    تومان
                                  </span>
                                </div>
                              </div>
                            ))}
                            {hasNext && (
                              <button
                                className="btn-submit"
                                onClick={() => setPage(page + 1)}
                              >
                                صفحه بعد
                              </button>
                            )}
                          </div>
                        </>
                      )}

                      {active == "wed" && (
                        <div>
                          <Bardasht />
                        </div>
                      )}

                      {active == "dep" && (
                        <div>
                          <Deposit flag={true} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MangeDashboard>
  );
}
